// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class BasicEnrollmentContact {
    static getAttributeTypeMap() {
        return BasicEnrollmentContact.attributeTypeMap;
    }
}
BasicEnrollmentContact.discriminator = undefined;
BasicEnrollmentContact.additionalProperties = false;
BasicEnrollmentContact.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "altPhoneNumber",
        "baseName": "altPhoneNumber",
        "type": "string"
    },
];
//# sourceMappingURL=basicEnrollmentContact.js.map